import { render, staticRenderFns } from "./editFloor.vue?vue&type=template&id=21be847d"
import script from "./editFloor.vue?vue&type=script&lang=js"
export * from "./editFloor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports